import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { baseOffersActions, baseOffersSelectors, BaseCoreState, BaseOffersListPayloadInterface } from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerOffersGuard {
  constructor(private store: Store<BaseCoreState>) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseOffersActions.loadOffersList({
        payload: route.queryParams as BaseOffersListPayloadInterface,
      })
    );

    return this.store.select(baseOffersSelectors.getOffersList).pipe(
      filter((state) => state.ok !== undefined),
      map((state) => state.ok as boolean)
    );
  }
}
